import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Tooltip from 'components/common/tool-tip-component';
import Button, { BUTTON_TYPES } from 'components/common/button-component';
import InfoIconComponent from './side-by-side-info-icon';

const TrialBalanceUnlink = ({
  BLOCK,
  isUnlinkDisabled,
  onClickUnlinkOmniaSnapshot,
}) => {
  return (
    <div className={`${BLOCK}__unlink-wrapper`}>
      <Tooltip
        text={'trial-balance-view.unlink.button.disabled.tooltip'}
        id={`${BLOCK}-unlink-tooltip`}
        active={isUnlinkDisabled}
      >
        <div className={`${BLOCK}__unlink`}>
          <Button
            id={'trial-balance-unlink-button'}
            type={BUTTON_TYPES.secondary}
            onClick={(e) => {
              e.stopPropagation();
              !isUnlinkDisabled && onClickUnlinkOmniaSnapshot();
            }}
            disabled={isUnlinkDisabled}
          >
            <FormattedMessage id={'trial-balance-view.unlink.button.text'} />
          </Button>
        </div>
      </Tooltip>
      <InfoIconComponent
        id={`${BLOCK}-info-tooltip`}
        tooltip={'trial-balance-view.unlink.button.info.tooltip'}
      />
    </div>
  );
};

TrialBalanceUnlink.propTypes = {
  /** Whether the unlink button should be disabled (e.g., when statement is wrapped up) */
  isUnlinkDisabled: PropTypes.bool.isRequired,
  /** Block name for CSS class prefixes */
  BLOCK: PropTypes.string.isRequired,
  /** Callback function triggered when unlink button is clicked */
  onClickUnlinkOmniaSnapshot: PropTypes.func.isRequired,
};
export default TrialBalanceUnlink;
